export default __webpack_public_path__ + "static/media/multiple_choice.87aae3ab.svg";